
import Vue from 'vue'

export default Vue.extend({
  name: 'CoreElementWrapper',
  props: {
    loading: {
      type: Boolean,
    },
    stackedButtons: {
      type: Boolean,
    },
    showLeft: {
      type: Boolean,
      default: true,
    },
    leftGapClasses: {
      type: String,
      default: '',
    },
    large: {
      type: Boolean,
    },
    micro: {
      type: Boolean,
    },
    wrap: {
      type: Boolean,
    },
    header: {
      type: Boolean,
    },
    metadataColor: {
      type: String,
      default: 'text-gray-metadata',
    },
    removeButtons: {
      type: Boolean,
    },
    isInert: {
      type: Boolean,
    },
    wrapTop: {
      type: Boolean,
    },
    alwaysWrapTop: {
      type: Boolean,
    },
    listDivider: {
      type: Boolean,
    },
    textContentClasses: {
      type: [String, Array, Object],
      default: '',
    },
  },
  computed: {
    topClasses(): string {
      if (this.alwaysWrapTop) {
        if (this.large) return '!w-1/3 xl:!w-3/10'
        return '!w-1/4'
      }
      if (this.large) return 'xs:!w-1/3 xl:!w-3/10'
      return 'xs:!w-1/4'
    },
  },
})
